import React from "react";
import { connect } from "react-redux";
import BeginInfoForm from "./BeginInfoForm";
import {
  updateEvaluation,
  evaluationState
} from "../../modules/evaluation/actions";

import { START_EVALUATION } from "../../modules/evaluation/constants";

class BeginInfoFormContainer extends React.Component {
  render() {
    if (this.props.user && this.props.user.experience) {
      this.props.evaluationState(START_EVALUATION);
    }

    
    return (
      <BeginInfoForm
        {...this.props}
        updateEvaluation={this.props.updateEvaluation}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    fullName: state.evaluation.fullName,
    email: state.user.user ? state.user.user.email : state.evaluation.email,
    age: state.evaluation.age,
    educationalLevel: state.evaluation.educationalLevel,
    leadershipExp: state.evaluation.leadershipExp,
    numberOfReferences: state.evaluation.numberOfReferences,
    language: state.preference.language
  };
}

const mapActionsToProps = {
  updateEvaluation,
  evaluationState
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(BeginInfoFormContainer);



// WEBPACK FOOTER //
// ./src/pages/Evaluation/BeginInfoFormContainer.js